var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isItemSet
        ? [
            _vm.selectionType === "manufacturer"
              ? [
                  _c("item-manufacturer-data-list", {
                    attrs: {
                      "visible-fields": _vm.visibleFields,
                      "item-components": _vm.setComponents
                    }
                  })
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.selectionType === "eu-responsible"
              ? [
                  _c("item-eu-responsible-data-list", {
                    attrs: {
                      "visible-fields-eu": _vm.visibleFieldsEu,
                      "item-components": _vm.setComponents
                    }
                  })
                ]
              : _vm._e()
          ]
        : _vm.isBundle
        ? [
            _vm.selectionType === "manufacturer"
              ? [
                  _c("item-manufacturer-data-list", {
                    attrs: {
                      "visible-fields": _vm.visibleFields,
                      "item-components": _vm.bundleComponents
                    }
                  })
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.selectionType === "eu-responsible"
              ? [
                  _c("item-eu-responsible-data-list", {
                    attrs: {
                      "visible-fields-eu": _vm.visibleFieldsEu,
                      "item-components": _vm.bundleComponents
                    }
                  })
                ]
              : _vm._e()
          ]
        : [
            _vm.selectionType === "manufacturer" && _vm.simpleItemManufacturer
              ? _c("manufacturer-details", {
                  attrs: {
                    "visible-fields": _vm.visibleFields,
                    manufacturer: _vm.simpleItemManufacturer
                  }
                })
              : _vm.selectionType === "eu-responsible" &&
                _vm.simpleItemManufacturer
              ? _c("eu-responsible-details", {
                  attrs: {
                    "visible-fields-eu": _vm.visibleFieldsEu,
                    manufacturer: _vm.simpleItemManufacturer
                  }
                })
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }